import { PrintMap } from "esdm-map/dist/map/Tools/PrintMap";
import { IPrintOptions } from "esdm-map/dist/map/tools/IPrintOptions";
import { DownloadMapPng } from "esdm-map/dist/map/Tools/DownloadMapPng";
import { IMapViewStore } from "esdm-map/dist/map/store/IMapViewStore";
import { IVectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupFactory";
import { IMapContextMenu } from "esdm-map/dist/map/tools/IMapContextMenu";
import { IFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureLoader";
import { OgcMapFilter } from "esdm-map/dist/map/filters/OgcMapFilter";
import { VectorLayerGroupFactory } from "esdm-map/dist/layers/groups/vector/VectorLayerGroupFactory";
import { MapViewStore } from "esdm-map/dist/map/store/MapViewStore";
import { MapContextMenu } from "esdm-map/dist/map/Tools/MapContextMenu";
import { ToolTipProvider } from "esdm-map/dist/map/tooltip/ToolTipProvider";
import { IVectorLayerGroupConfig } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { GeoJsonFeatureLoader } from "esdm-map/dist/layers/vector/sources/loaders/GeoJsonFeatureLoader";
import { ILoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/ILoaderExtentsBehaviour";
import { BoundsLoaderExtentsBehaviour } from "esdm-map/dist/layers/vector/sources/loaders/behaviours/BoundsLoaderBehaviour";
import { IFeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/interfaces/IFeatureAdd";
import { FeatureAdd } from "esdm-map/dist/layers/vector/sources/loaders/FeatureAdd";
import { MapListRecordsInViewport } from "esdm-map/dist/map/MapListRecordsInViewport";
import { ExtentsNavigation } from "esdm-map/dist/map/controls/ExtentsNavigation";
import { LayerGroupFactory } from "esdm-map/dist/layers/groups/LayerGroupFactory";
import { LayerGroupCollection } from "esdm-map/dist/layers/groups/LayerGroupCollection";
import { MapFilters } from "esdm-map/dist/map/filters/MapFilters";
import { GridRef } from "esdm-map/dist/map/controls/GridRef";
import { GeoLocation } from "esdm-map/dist/map/geolocation/geolocation";
import { MapPopup, MapPopupOptions } from "esdm-map/dist/map/MapPopup";
import { IMappingTextPack } from "esdm-map/dist/resources/MappingTextPack";
import { MousePosition } from "esdm-map/dist/map/controls/MousePosition";
import { OsOpenNames } from "esdm-map/dist/gazetteer/os/OsOpenNames";
import { MapViewSettingsUrlProvider } from "esdm-map/dist/map/store/MapViewSettingsUrlProvider";
import { IMapViewPermaLink } from "esdm-map/dist/map/Tools/IMapViewPermaLink";
import { MapViewPermaLink } from "esdm-map/dist/map/Tools/MapViewPermaLink";

import { HbsmrStyleFactory } from "./HbsmrStyleFactory";
import { HbsmrResourcefactory } from "./HbsmrResourceFactory";
import { ColchesterRecordType, ColchesterRecordSubType } from "./ColchesterRecordTypes";
import { DefaultLayerConfigurationFactory } from "./DefaultLayerConfigurationFactory";
import { DefaultMapOptions } from "./DefaultMapOptions";
import { TextPackLoader, TextPacks } from "./TextPackLoader";
import {
    MapOptions,
    IMap,
    MapLayerSwitcher,
    IMapAreaMask,
    ILogger,
    IResourceFactory,
    IMapListRecordItem,
    IMapFactory,
    BaseLayerFactory_3857,
    MapFactory,
    Logger
} from "esdm-map";

import { GeoNames } from "esdm-map/dist/gazetteer/geonames";
import { FeatureAddSmallGeomsAsPoint } from "esdm-map/dist/layers/vector/sources/loaders";
import { IStyleFactory } from "esdm-map/dist/layers/vector/styles/IStyleFactory";
import { IVectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources/interfaces";
import { VectorLayerSourceFactory } from "esdm-map/dist/layers/vector/sources";
import { IMapViewSettingProvider } from "esdm-map/dist/map/store/IMapViewSettingsProvider";
import { IBaseLayerFactory } from "esdm-map/dist/baselayers/interfaces/IBaseLayerFactory";
import { ColchesterHerBoundary } from "./ColchesterHerBoundary";
import { LayerGroupCollections } from "esdm-map/dist/layers/groups/LayerGroupCollections";
import { MapBase } from "./MapBase";
import { HbsmrIdentity, HbsmrUser } from "./HbsmrUser";
import { IlayerGroupCollectionConfig } from "esdm-map/dist/layers/groups/IlayerGroupCollectionConfig";

import Fill from "ol/style/Fill";
import Style from "ol/style/Style";
import TextStyle from "ol/style/Text";
import { Tooltip } from "bootstrap"
import { debounce } from "debounce"

import "../wwwroot/css/ol.css";
import "../wwwroot/css/bootstrap-select.css"
import "../wwwroot/css/ol-contextmenu.css";
import "../node_modules/ol-ext/control/Swipe.css";
import { CustomClient_BaseLayerFactory_3857 } from "./customTypings/CustomClient_BaseLayerFactory_3857";

import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS.js';
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
import TileLayer from "ol/layer/Tile";

$(function () { 

    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    });

    let printOptions: PrintMap = new PrintMap();

    if (!printOptions.isPrintMap) {
        resizeMap();
        window.addEventListener('resize', debounce(resizeMap, 250));    
    }

    function resizeMap() {
        //use max footer height, especially on mobile
        var fHeight = $("footer").height();
        fHeight = Math.min(fHeight, 200);

        var height = $(window).height() - $("#mapContainer").offset().top;
        if (height <= 400) {
            height = 400;
        }
        $('#mapContainer').height(height);
        $("#slide-content").height(height - 55);
    };



    let ele = $("#theMap");
    if (ele.length === 1) {
        HbsmrIdentity.fetch().then(function (e) {
            //let user = e;
            //if (e) {
            //    console.log(e.userId);
            //} else {
            //    console.log("401 - UnAuthorised");
            //}
            loadMap(e);           
        });
    }

    function loadMap(user: HbsmrUser) {
        let maxFeatureCount: number = <number>ele.data("max-feature-count");
        let init = function (textpacks: TextPacks) {
            let map = new MainMap("theMap", maxFeatureCount, printOptions, textpacks.mapping, user);
        }
        TextPackLoader.load().then(init);
    }

});
export class MainMap extends MapBase {
        
    private mfOptions: MapOptions;
    public map: IMap;
    private mapStore: IMapViewStore;
    private ls: MapLayerSwitcher;
    private infoPopup: MapPopup;
    private initialised: boolean = false;
    private layerGroups: LayerGroupCollections;
    private styleFactory: IStyleFactory;
    private herMask: IMapAreaMask;
    private geoNames: GeoNames;
    private gridRefFinder: GridRef;
    private logger: ILogger;   
    private vectorLayerSourceFactory: IVectorLayerSourceFactory;
    private baseLayerFactory: IBaseLayerFactory;
    private mapFactory: IMapFactory;
    private vectorLayerGroupFactory: IVectorLayerGroupFactory;
    private layerGroupFactory: LayerGroupFactory;
    private boundsLoaderBehaviour: ILoaderExtentsBehaviour;
    private mapContextMenu: IMapContextMenu;
    private resourcefactory: IResourceFactory;    
    private downloadPng: DownloadMapPng;
    private featureLoader: IFeatureLoader;
    private featureAdd: IFeatureAdd;
    private mapFilter: MapFilters;
    private recordList: MapListRecordsInViewport;
    private geoLocation: GeoLocation;
    private extentsNavigation: ExtentsNavigation;
    private layerConfigFactory: DefaultLayerConfigurationFactory;
    private mapViewSettingProvider: MapViewSettingsUrlProvider;
    private mapListRecordItem: IMapListRecordItem;
    private mapViewPermaLink: IMapViewPermaLink;
    private mousePosition: MousePosition;

    public constructor(
        public mapElementId: string,       
        public maxFeatureCount: number,
        public printOptions: IPrintOptions,
        public mappingTextPack: IMappingTextPack,
        user: HbsmrUser)
    {
        super(mappingTextPack, user);
        this.init();
    }

    private init = (): void => {
        if (!this.initialised) {
            //strip-loader should take this out for production
            console.log("Initialising main map");                       
                        
            this.layerConfigFactory = new DefaultLayerConfigurationFactory();
            this.vectorLayerGroupFactory = new VectorLayerGroupFactory(); 
            this.layerGroupFactory = new LayerGroupFactory(this.vectorLayerGroupFactory, null);
            this.baseLayerFactory = new CustomClient_BaseLayerFactory_3857();            
            this.featureLoader = new GeoJsonFeatureLoader();
            //this.featureAdd = new FeatureAddSmallGeomsAsPoint();
            this.featureAdd = new FeatureAdd();
            this.mapFilter = new MapFilters();
            this.mapFilter.OgcFilter = new OgcMapFilter();
            this.mapFactory = new MapFactory();
            this.logger = new Logger();           
            this.styleFactory = new HbsmrStyleFactory();
            this.resourcefactory = new HbsmrResourcefactory(this.mappingTextPack);

            this.mfOptions = DefaultMapOptions.GetDefaultOptions(this.mapElementId, "MainMap");           
            this.layerGroups = this.layerGroupFactory.getLayerGroups(this.getLayerGroupConfig(), this.styleFactory);
            this.mfOptions.layerGroupCollection = this.layerGroups;
            
            this.mapViewSettingProvider = new MapViewSettingsUrlProvider();
            this.mapStore = new MapViewStore(this.mfOptions.mapStoreKey, this.mapViewSettingProvider);
            
            this.boundsLoaderBehaviour = new BoundsLoaderExtentsBehaviour(this.logger);            
            this.mapContextMenu = new MapContextMenu(this.mappingTextPack);

            this.vectorLayerSourceFactory = new VectorLayerSourceFactory(this.logger, this.boundsLoaderBehaviour, this.featureLoader, this.featureAdd);
            this.map = this.mapFactory.instance(this.mfOptions, this.mapStore, this.logger, this.vectorLayerSourceFactory, this.baseLayerFactory, this.boundsLoaderBehaviour, this.mapContextMenu, this.printOptions, this.mapFilter, this.mappingTextPack);

            this.herMask = new ColchesterHerBoundary();
            this.map.olMap.addLayer(this.herMask.getMask());

            this.infoPopup = new MapPopup(this.map, this.resourcefactory.getRecordTypeResource(), new ToolTipProvider(), new MapPopupOptions(11));
            this.ls = new MapLayerSwitcher(this.map, this.mapStore, this.styleFactory, this.map.baseLayers, this.layerGroups, this.mappingTextPack,
                {
                    showOpenPanelByDefault: !this.printOptions.isPrintMap,
                    rememberActivePanel: true
                });
            this.gridRefFinder = new GridRef(this.map, this.mappingTextPack, this.logger);
            this.geoNames = new GeoNames(this.map, this.mappingTextPack);             

            if (this.printOptions.isPrintMap) {                
                this.printOptions.setMap(this.map);
                setTimeout(() => {
                    this.map.olMap.updateSize();
                }, 100);
            } 

            this.downloadPng = new DownloadMapPng(this.map, this.mappingTextPack);           
            this.recordList = new MapListRecordsInViewport(this.map, this.mapStore, this.styleFactory, this.layerGroups.vectorLayerGroups, this.mappingTextPack, 14, this.mapListRecordItem);
            //this.geoLocation = new GeoLocation(this.map, this.logger);
            this.extentsNavigation = new ExtentsNavigation(this.map, this.logger, this.mappingTextPack);
            this.mousePosition = new MousePosition(this.map, this.mappingTextPack);            
            this.mapViewPermaLink = new MapViewPermaLink(this.map, this.mapViewSettingProvider, this.mappingTextPack, {activePanel:"overlays"});
            this.initialised = true;
        }
    }

    
    private getLayerGroupConfig = (): Array<IlayerGroupCollectionConfig> => {       

        let layerGroupConfig: Array<IVectorLayerGroupConfig> = [
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Monument, null, { visibleOnFirstLoad: true}),
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Event),
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.ScheduledMonument),
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.ListedBuilding),     
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.ConservationArea),
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.RegisteredParksAndGardens),
            this.layerConfigFactory.layerConfig(ColchesterRecordType.Designation, ColchesterRecordSubType.LocalList)

        ];

        return [
            {
                ref: "all_layers",
                name: "All layers",
                useAccordion: false,
                expandedOnFirstLoad: true,
                layerGroupConfigs: this.filterMapLayers(layerGroupConfig)
            }
        ];
    }

}




